export { };

declare global {
  interface String {
    toTitleCase(): string;
  }
}

String.prototype.toTitleCase = function () {
  return this.replace(/(^|\s)\S/g, (t) => t.toUpperCase());
};
